module.exports = __webpack_public_path__ + "media/images/getaccept-412452b3ace41e5e78aed71bae4a5fb9.svg";